import { connect } from "react-redux";
import React, { useEffect, useMemo, useState } from "react";
import {
    CAlert,
    CCol,
    CNav,
    CNavItem, CNavLink,
    CTabContent, CTabPane
} from "@coreui/react";
import TouchKeyManage from "../../touch/TouchKeyManage";
import HandleProductRest from "../HandleProductRest";
import HandleProductStoreCorner from "../HandleProductStoreCorner";
import KioskTouchKeyManage from "../../touch/KioskTouchKeyManage";

const ProductHandlingManage = (props) => {
    const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
    const [error, setError] = useState({
        visible: false,
        message: ""
    });
    const [activeKey, setActiveKey] = useState(1);

    useEffect(() => {
        if (props.selected.storeCd.length > 0) {
            // getStoreDevice();
        }
    }, [props.selected.storeCd]);

    return (
        <>
            <div style={containerStyle}>
                {error.visible ? <CAlert color="danger" dismissible={true}>{error.message}</CAlert> : null}
                <div className="d-grid gap-1 d-md-flex justify-content-between" style={{ marginBottom: 10 }}>
                    <h5>취급상품관리</h5>
                </div>
                <CCol>
                    <CNav variant="tabs" role="tablist">
                        <CNavItem>
                            <CNavLink
                                active={activeKey === 1}
                                onClick={() => setActiveKey(1)}>휴게소취급상품</CNavLink>
                        </CNavItem>
                        <CNavItem>
                            <CNavLink
                                active={activeKey === 2}
                                onClick={() => setActiveKey(2)}>매장(코너)취급상품</CNavLink>
                        </CNavItem>
                        <CNavItem>
                            <CNavLink
                                active={activeKey === 3}
                                onClick={() => setActiveKey(3)}>POS 터치키 관리</CNavLink>
                        </CNavItem>
                        <CNavItem>
                            <CNavLink
                                active={activeKey === 4}
                                onClick={() => setActiveKey(4)}>KIOSK 터치키 관리</CNavLink>
                        </CNavItem>
                    </CNav>
                    <CTabContent>
                        <CTabPane role="tabpanel" aria-labelledby="basic-tab" visible={activeKey === 1}>
                            <div style={{height: 10}}/>
                            <HandleProductRest />
                        </CTabPane>
                        <CTabPane role="tabpanel" aria-labelledby="basic-tab" visible={activeKey === 2}>
                            <div style={{height: 10}}/>
                            <HandleProductStoreCorner />
                        </CTabPane>
                        <CTabPane role="tabpanel" aria-labelledby="basic-tab" visible={activeKey === 3}>
                            <div style={{height: 10}}/>
                            <TouchKeyManage />
                        </CTabPane>
                        <CTabPane role="tabpanel" aria-labelledby="basic-tab" visible={activeKey === 4}>
                            <div style={{height: 10}}/>
                            <KioskTouchKeyManage />
                        </CTabPane>
                    </CTabContent>
                </CCol>
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    const { account, store, selected } = state;
    return {
        account, store, selected
    };
};

export default connect(mapStateToProps, null)(ProductHandlingManage);
